import React, { useEffect, useState } from 'react';
import { useFetchPageData, usePageData } from '../../../../hooks/usePage';
import { Button, Card, Col, message, Result, Row, Tooltip, Transfer } from 'antd';
import { IPageData } from '../../../../interfaces/page';
import { IEleccion } from '../../../../interfaces/elecciones/eleccion';
import EleccionVigente from './component/eleccionvigente';
import eleccionesProvider from '../../../../services/eleccionesProvider';
import { IResponse } from '../../../../interfaces/response';
import { navigateHome } from '../../../../utils/naviagate-home';
import administracionProvider from '../../../../services/administracionProvider';

const pageData: IPageData = {
  fulFilled: false,
  breadcrumbs: [
    {
      title: 'Comité SST',
      route: 'default-dashboard'
    },
    {
      title: 'Electores'
    }
  ]
};

const mockData = [];
for (let i = 0; i < 20; i++) {
  mockData.push({
    key: i.toString(),
    title: `content${i + 1}`,
    description: `description of content${i + 1}`,
    disabled: i % 3 < 1
  });
}

const ElectoresAdmin = () => {
  usePageData(pageData);
  const [data] = useFetchPageData<IEleccion>('/elecciones/ObtenerEleccionVIgente', null);

  useEffect(() => {
    if (data != null) {
      const filter = data.usuariosHabilitados.map((x) => x.id);
      setTargetkey(filter);
    }
  }, [data]);

  const [selectedKeys, setselectedKeys] = useState([]);
  const [targetKey, setTargetkey] = useState([]);

  const handleChange = (nextTargetKeys, direction, moveKeys) => {
    setTargetkey(nextTargetKeys);
  };
  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setselectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  const handleScroll = () => {};

  const guardarElectores = async () => {
    const res: any = await eleccionesProvider.guardarElectores(targetKey);
    //TODO VALIDAR
    if (res.succeeded) {
      message.success(res.message);
      navigateHome();
    } else {
      message.warning(res.message);
    }
  };

  const notificar = async () => {
    const correos = {
      correos: [],
      titulo:
        'Elección – Representantes de los Trabajadores Comité de Intervención frente al Hostigamiento Sexual 2026-2028',
      contenido: ''
    };
    const res = await administracionProvider.notificarCorreos(correos);
  };

  return (
    <>
      {data != null ? (
        <Card title={'Configuración de Electores'}>
          <Tooltip title='Se registra la lista de los usuarios habilitados para realizar la votacion en el presente periodo.'>
            <Button htmlType={'button'} onClick={notificar}>
              Notificar a Electores
            </Button>
            <Button
              htmlType={'button'}
              onClick={guardarElectores}
              disabled={targetKey.length === 0 || data.eleccion.finVotacion}
              style={{ marginBottom: 5 }}
              type='primary'
            >
              Guardar Electores
            </Button>
          </Tooltip>
          <Row>
            <Col span={16}>
              <Transfer
                dataSource={data.usuariosDisponibles}
                showSearch={true}
                listStyle={{ width: 300, height: 500 }}
                titles={['Usuarios', 'Electores']}
                targetKeys={targetKey}
                selectedKeys={selectedKeys}
                onChange={handleChange}
                onSelectChange={handleSelectChange}
                onScroll={handleScroll}
                filterOption={(search, item) => {
                  const elector = item.nombres + ' ' + item.apellidos;
                  return elector.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                }}
                render={(item) => `${item.nombres} ${item.apellidos}`}
                disabled={false}
                locale={{
                  searchPlaceholder: 'Buscar usuario...',
                  itemUnit: 'Usuario',
                  itemsUnit: 'Usuarios'
                }}
                oneWay
                style={{ marginBottom: 16 }}
              />
            </Col>
            <Col span={8}>
              {data.eleccion != null ? (
                <EleccionVigente eleccion={data} />
              ) : (
                <Result
                  status='info'
                  title='GESSOMA'
                  subTitle='Actualmente no existe una Elección configurada.'
                />
              )}
            </Col>
          </Row>
        </Card>
      ) : (
        <Card title={'No existe perioro vigente'}>
          <p>Añadir Postulantes a la Elección vigente:</p>
        </Card>
      )}
    </>
  );
};

export default ElectoresAdmin;
